import { ApiClient } from "./api-client";
import type { Shortlist, UpdateListParams, UserContextId } from "./types";

export default class ShortlistClient extends ApiClient {
    constructor({ baseURL, useEnv }: { baseURL?: string; useEnv?: boolean }) {
        super({
            baseURL,
            useEnv,
            apiPrefix: "shortlist",
        });
    }

    async getByUserContextId({ userContextId }: UserContextId): Promise<Shortlist> {
        return super.makeGetRequest<Shortlist>(`/${userContextId}`);
    }

    async addToList({ userContextId, stockNumber }: UpdateListParams): Promise<Shortlist> {
        return super.makePostRequest<Shortlist>(`/${userContextId}/${stockNumber}`);
    }

    async removeFromList({ userContextId, stockNumber }: UpdateListParams): Promise<Shortlist> {
        return super.makeDeleteRequest<Shortlist>(`/${userContextId}/${stockNumber}`);
    }

    async removeAll({ userContextId }: UserContextId): Promise<Shortlist> {
        return super.makeDeleteRequest<Shortlist>(`/${userContextId}`);
    }
}
